import React from 'react'

function SkeletonAllAlerts() {
    return (
        <div className="p-[30px] bg-white rounded-[10px] flex flex-col gap-3 min-h-full">
            {Array.from({ length: 8 }).map((_, idx) => (
                <div className="flex items-center justify-between px-3 bg-[rgb(250,250,252)] rounded-2xl animate-pulse h-[68px]">
                    <div className="flex items-center space-x-[10px]">
                        <div className="rounded-full bg-lightBG" style={{ width: '40px', height: '40px' }} />
                        <div className="flex flex-col space-y-2">
                            <div className="h-4 bg-lightBG rounded" style={{ width: '150px' }} />
                            <div className="h-4 bg-lightBG rounded" style={{ width: '80px' }} />
                        </div>
                    </div>
                    <div className="flex items-center space-x-3">
                        <div className="h-8 rounded-full bg-lightBG" style={{ width: '132px' }} />
                        <div className="h-8 rounded-full bg-lightBG" style={{ width: '153px' }} />
                        <div className="w-10 h-10 bg-lightBG rounded-full" />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default SkeletonAllAlerts
